export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';

export const TIMEOUT_SEC = 5;
export const RES_PER_PAGE = 10;
export const KEY = '5b416524-f27d-474e-815d-e7efd54fa642';
export const MODEL_CLOSE_SEC = 1;
